/** @format */

import { ISkuLocation } from './sku-location.interface';

export interface SkuLocationResponse {
  data: {
    skus: ISkuLocation[];
  };
  meta: {
    key: 'TOTAL_RESULT_COUNT';
    value: string;
  }[];
  status: 'OK' | 'NOT_OK';
}
